// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/update/index.css
// module id = 873
// module chunks = 41